import moment from 'moment';

export const getDateFormatter = (
  date: string | Date,
  format: string = 'YYYY-MM-DD'
) => {
  if (!date) {
    return '';
  }
  return moment(new Date(date)).format(format);
};

/**
 * DropDown `maxRange` disables values strictly below it.
 * Only constrain the end month when the end year is the same as the start year,
 * otherwise all 12 months must stay selectable.
 */
export const endMonthMinValue = (
  startYear?: string,
  startMonth?: string,
  endYear?: string
): number => {
  if (
    !startYear ||
    !startMonth ||
    !endYear ||
    String(startYear) !== String(endYear)
  ) {
    return 0;
  }
  const month = Number(startMonth);
  return Number.isFinite(month) ? month : 0;
};

/** Same-year + same-month only: end day cannot be before start day. */
export const endDayMinValue = (
  startYear?: string,
  startMonth?: string,
  startDay?: string,
  endYear?: string,
  endMonth?: string
): number => {
  if (
    !startYear ||
    !startMonth ||
    !startDay ||
    !endYear ||
    !endMonth ||
    String(startYear) !== String(endYear) ||
    String(startMonth) !== String(endMonth)
  ) {
    return 0;
  }
  const day = Number(startDay);
  return Number.isFinite(day) ? day : 0;
};
